import { useEffect, useState } from "react";

const MultiSelectBtns = ({
  values,
  onChange,
  options,
  label,
  name,
  errors,
  touched,
  disabled,
  multiselect
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (value) => {
    let tmpIsChecked = false;
    if (Array.isArray(values)) {
      tmpIsChecked = values?.find((a) => a == value) != undefined;
    } else {
      tmpIsChecked = value == values;
    }
    if (multiselect) {
      if (tmpIsChecked) {
        onChange(values.filter((item) => item !== value));
      } else {
        onChange([...values, value]);
      }
    } else {
      onChange([value]);
    }
  };
  const checkIfButtonChecked = (value) => {
    let tmpIsChecked = false;
    if (Array.isArray(values)) {
      tmpIsChecked = values?.find((a) => a == value) != undefined;
    } else {
      tmpIsChecked = value == values;
    }
    return tmpIsChecked;
  };

  return (
    <div>
      <label className="block mb-2 text-lg ">{label}</label>
      <div className="flex flex-wrap  gap-2">
        {options.map((op) => (
          <div
            onClick={() => !disabled && handleCheckboxChange(op.value)}
            className={`p-2 bg-slate-200 cursor-pointer border-4 ${
              checkIfButtonChecked(op.value)
                ? " border-primary"
                : "border-slate-200"
            }`}
          >
            <p>{op.label}</p>
            {/* <label className="inline-flex items-center mr-4">
                        <input
                            type="checkbox"
                            value={op.value}
                            checked={values?.includes(op.value)}
                            onChange={() => handleCheckboxChange(op.value)}
                            className="form-checkbox h-3 w-3 text-primary"
                            disabled={disabled}
                        />
                        <span className="ml-2 text-xs">{op.label}</span>
                    </label> */}
          </div>
        ))}
      </div>
      <p className="h-5 text-xs text-red-500">{errors?.[name]}</p>
    </div>
  );
};

export default MultiSelectBtns;
